import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { ContractCounterViewModel } from "../ProcessingActivityStatistics.types";
import { useProcessingActivityStatisticsStyles } from "../processingActivityStatistics.styles";
import { useTranslation } from "../../../localization/useTranslation";
import DotLegalPaper from "../../../common/components/dotLegalPaper/DotLegalPaper";
import { getCounter } from "../ProcessingActivityStatisticsContent";

export interface ContractCounterProps {
    contractCounter: ContractCounterViewModel | undefined;
}

function ContractCounter(props: ContractCounterProps) {
    const styles = useProcessingActivityStatisticsStyles();
    const { translateString, translateDocumentType } = useTranslation();
    return (
        <Box>
            <DotLegalPaper backgroundColor="lightPurple" fullHeight>
                <Typography sx={styles.header}>{translateString("numberOfContracts")}</Typography>
                <Typography sx={styles.body}>{props?.contractCounter?.totalNumber}</Typography>
            </DotLegalPaper>
            <Grid sx={styles.footer} container columnSpacing={5} rowSpacing={0.5}>
                {getCounter("CTA", props!.contractCounter!.numberOfCTA)}
                {getCounter(translateDocumentType("5"), props!.contractCounter!.numberOfCooperationAgreements)}
                {getCounter(translateDocumentType("7"), props!.contractCounter!.numberOfPHDAgreements)}
                {getCounter(translateDocumentType("2"), props!.contractCounter!.numberOfDataProcessorAgreements)}
                {getCounter(translateDocumentType("9"), props!.contractCounter!.numberOfJointDataControllerAgreements)}
                {getCounter(translateDocumentType("6"), props!.contractCounter!.numberOfServiceAgreements)}
                {getCounter(translateDocumentType("8"), props!.contractCounter!.numberOfDisclosureAgreements)}
                {getCounter(translateDocumentType("10"), props!.contractCounter!.numberOfOtherAgreements)}
            </Grid>
        </Box>
    );
}

export default ContractCounter;
